import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import { useModel } from "@stem-sims/nexus"
import generalStyles from "../General/general.module.scss"
import EmptyTablePreview from "../General/EmptyTablePreview"
import student from "shared/routes/student"
import { StudentAssignmentResponse, ClassResponse } from "shared/types/studentTypes"
import Assignments from "../General/Assignments"
import { getStudentSubmissionId, getTopicSubmissionId } from "helpers/getSubmissionId"
import { getSubmissions } from "shared/routes/assignments"
import { StudentAssignmentStateProps } from "shared/types/moduleTypes"
interface StudentAssignmentsProps {
    activeClass: ClassResponse
}


export default function StudentAssignments({ activeClass }: StudentAssignmentsProps) {
    const navigate = useNavigate()

    const { response: assignments, loading} = useModel({
        model: student.getAssignments,
        onError: (err) => (toast.error(err.response?.data?.message ?? "There has been an error loading the assignments. Please try again.")),
        props: { classId: activeClass?.id, assignmentType: "stemsims" }
    })

    const openAssignment = async (assignment: StudentAssignmentResponse) => {
        try {
            const { data: submissions } = await getSubmissions({ assignmentId: assignment.id })
            const recentSubmission = submissions?.[0]

            const reworkAssignmentMode = recentSubmission?.status === "rework-required" || recentSubmission?.status === "reworking"

            let studentSubmissionId = null
            let startFromAssessment = false

            if (assignment?.topicId) {
                studentSubmissionId = await getTopicSubmissionId({assignment, recentSubmission})
            } else {
                studentSubmissionId = await getStudentSubmissionId({assignment, recentSubmission})
                startFromAssessment = (recentSubmission?.lessonSubmittedDate && recentSubmission?.assessmentGrade === null && recentSubmission?.lessonGrade == null) ? true : false
            }

            if (assignment?.review) {
                navigate("/dashboard/student/reviews", { state: { assignmentId: assignment.id } })
                return
            } else {
            navigate("/dashboard/student/assignments/assignment", {
                state: {
                    submissionId: studentSubmissionId,
                    assignment: assignment,
                    continueAssessment: startFromAssessment,
                    reworkAssignmentMode: reworkAssignmentMode,
                    isReview: false,
                    } as StudentAssignmentStateProps
                })
            }
        } catch (err) {
            toast.error(err?.response?.data?.message ?? "Unable to start assignment, please try again.")
        }
    }

    const extraCols = [
        {
            Header: 'Status',
            accessor: "status",
        },
    ]

    const onRowClick = (row) => {
        const assignment: StudentAssignmentResponse = row.original
        openAssignment(assignment)
    }

    const changeBackgroundColor = (row) => {
        const assignment: StudentAssignmentResponse = row.original
        return assignment.userHasAccess ? "" : `${generalStyles.unavailableAssignment}`
    }

    const AssignmentsComponent = <Assignments origin="stemsims" extraTeacherComponents={[]} assignments={assignments} onRowClick={onRowClick} changeBackgroundColor={changeBackgroundColor} extraCols={extraCols} loading={loading} rowTooltip="Start the assignment" />
    const EmptyTableComponent = <EmptyTablePreview title="Assignments" description="Your teacher has not added any assignments yet." />
    return (<>
            <h1 className="text-start mt-3">Assignments</h1>
            <p className={`text-start ${generalStyles.greyText}`}>
                View the status of your assignments.
            </p>
            {(loading || assignments?.length > 0) ? AssignmentsComponent : EmptyTableComponent}
    </>)
}
